import React from 'react';
import "./mobileAppSectionComponent.scss";
import MobileAppSectionTitle from "./components/MobileAppSectionTitle";
import MobileAppSectionVideoFrame from "./components/MobileAppSectionVideoFrame";

const MobileAppSectionComponent = () => {
    return (
        <div className="mobileAppSectionComponent__container">
            <MobileAppSectionTitle />
            <MobileAppSectionVideoFrame />
        </div>
    );
};

export default MobileAppSectionComponent;